import { render, staticRenderFns } from "./FilterRace.vue?vue&type=template&id=2065e7ae&scoped=true&lang=pug&"
import script from "./FilterRace.vue?vue&type=script&lang=js&"
export * from "./FilterRace.vue?vue&type=script&lang=js&"
import style0 from "./FilterRace.vue?vue&type=style&index=0&id=2065e7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065e7ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VMenu,VSpacer})
